// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".top-content{display:inline-block;height:15px}.ps__rail-x{opacity:.6!important;display:block!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
